import React, { useEffect, createElement } from 'react';
export const ClarityTracking = () => {
  useEffect(() => {
    // Create clarity tracking script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "sb3h68sxft");
    `;
    // Append to document head
    document.head.appendChild(script);
    // Clean up
    return () => {
      document.head.removeChild(script);
    };
  }, []);
  return null;
};